<template>
  <f7-page :page-content="false">
<!--    :title="activity.name"-->
    <f7-navbar back-link="" :back-link-force="true">
      <f7-nav-right>
        <activity-notes-button :always_visible="true" :activity="activity"></activity-notes-button>
        <activity-settings-button :always_visible="true" :activity="activity"></activity-settings-button>
      </f7-nav-right>
    </f7-navbar>


    <f7-tabs>
      <f7-tab id="exercise" tab-active class="page-content">

        <f7-card class="mb-1 card-raised"
                 :title="activity.name"
        ></f7-card>

        <swiper-container
          navigation="true"
          speed="500"
          slides-per-view="1"
          space-between="20"
          initial-slide="1"
        >
          <swiper-slide>
            <f7-card class="activity-swiper-card mt-1 card-raised">
              <f7-block>
                <f7-row>
                  <f7-col v-html="safeDescription"></f7-col>
                </f7-row>
              </f7-block>
            </f7-card>
            <activity-rep-set-pickers
                :rep_sets="rep_sets"
                :activity="activity"
                :training_session="training_session"
            ></activity-rep-set-pickers>
          </swiper-slide>

          <swiper-slide>
            <f7-card class="activity-swiper-card mt-1 card-raised">
              <f7-block>
                <f7-row>
                  <f7-col>
                    <template v-if="this.activity.video_tutorials.length">
                      <video style="width:100%;" class="my-2"  autoplay loop playsinline>
                        <source :src="video_1" type="video/mp4">
                      </video>
                      <video style="width:100%;" class="my-2"  autoplay loop playsinline>
                        <source :src="video_2" type="video/mp4">
                      </video>
                    </template>
                    <template v-else>
                      <div class="my-3">
                        Geen video beschikbaar voor deze oefening
                      </div>
                    </template>
                  </f7-col>
                </f7-row>
              </f7-block>
            </f7-card>
            <activity-rep-set-pickers
                :rep_sets="rep_sets"
                :activity="activity"
                :training_session="training_session"
            ></activity-rep-set-pickers>
          </swiper-slide>

          <swiper-slide>
            <f7-card class="activity-swiper-card mt-1 card-raised">
              <div class="muscle-image-container d-flex justify-content-center" style="position:relative;">
                <img class="muscle-image" :src="rootUrl + '/static/images/muscles/' + image" alt="" v-for="image in muscle_group_images">
              </div>
            </f7-card>
            <activity-rep-set-pickers
                :rep_sets="rep_sets"
                :activity="activity"
                :training_session="training_session"
            ></activity-rep-set-pickers>
          </swiper-slide>

          <swiper-slide>
            <activity-weight-calculator-card  class="activity-swiper-card mt-1"
                @overwrite_rep_sets="overwrite_rep_sets($event)"
               :activity="activity">
            </activity-weight-calculator-card>
            <activity-rep-set-pickers
                :rep_sets="rep_sets"
                :activity="activity"
                :training_session="training_session"
            ></activity-rep-set-pickers>
          </swiper-slide>
        </swiper-container>

<!--        <activity-rep-set-pickers-->
<!--            :rep_sets="rep_sets"-->
<!--            :activity="activity"-->
<!--            :training_session="training_session"-->
<!--        ></activity-rep-set-pickers>-->

      </f7-tab>

    </f7-tabs>

    <activity-settings-sheet-modal
      :show="showActivitySettings"
      @closed="showActivitySettings = false"
      :activity="activity"
      :training_session="training_session"
    >
    </activity-settings-sheet-modal>

  </f7-page>
</template>

<script>

  import Utility from "../../../../../js/utility";
  import ActivitySettingsSheetModal from "../../../../../components/activities/ActivitySettingsSheetModal.vue";
  import ActivityWeightCalculatorCard from "../../../../../components/activities/ActivityWeightCalculatorCard.vue";
  import ActivityNotesButton from "../../../../../components/activities/ActivityNotesButton.vue";
  import { f7, f7ready, theme } from 'framework7-vue';
  import ActivitySettingsButton from "../../../../../components/activities/ActivitySettingsButton.vue";
  import ActivityRepSetPickers from "../../../../../components/activities/ActivityRepSetPickers.vue";
  import { sanitiseExerciseHtml } from "../../../../../js/sanitise";
  import { register } from 'swiper/element/bundle';

  register();

  export default {
    components: {
      ActivityRepSetPickers,
      ActivitySettingsButton,
      ActivitySettingsSheetModal,
      ActivityWeightCalculatorCard,
      ActivityNotesButton,
    },

    props: {
      f7route: Object,
      f7router: Object,
    },

    mixins: [],

    data: function () {
      return {
        // Used to store the Pickers that change the rep values.
        rep_set_pickers: [],

        rep_sets: [],

        // Used to open the Activity Settings modal
        showActivitySettings: false,
        // Used to open the Activity Notes modal
        showActivityNotes: false,
      };
    },

    computed: {
      rootUrl() {
        return import.meta.env.PG_ROOT_URL;
      },
      activity_id() {
        return parseInt(this.f7route.params.activity_id);
      },
      training_session_id() {
        return parseInt(this.f7route.params.training_session_id);
      },
      training_session() {
        return this.$store.getters['training_sessions/find'](this.training_session_id);
      },
      activity() {
        return this.$store.getters['activities/find'](this.activity_id);
      },
      /**
       * Sanitised exercise description for the `v-html` binding above.
       *
       * The value's server source is `exercises.description`, NOT an
       * `activities.description` column — that column does not exist.
       * `ActivityResource.php:32` reads `$this->exercise->description`.
       *
       * A computed rather than an inline call: this component re-renders on
       * every rep-set change, and re-sanitising a description that never
       * changes would be pure waste.
       *
       * @returns {string}
       */
      safeDescription() {
        return sanitiseExerciseHtml(this.activity.description);
      },
      muscle_group_images() {
        let images = [];
        if(typeof this.activity.muscle_groups === 'undefined') {
          return images;
        }
        this.activity.muscle_groups.forEach(muscle_group => {
          images.push(muscle_group.toLowerCase() + '.svg');
        })
        return images;
      },
      exercise_videos() {
        return this.$store.getters['api/exercise_videos_url'];
      },
      video_1() {
        return this.activity.video_tutorials[0];
        // return this.exercise_videos + '/' + this.activity.original_name + '-' + this.activity.equipment + '-Male_1.gif';
      },
      video_2() {
        return this.activity.video_tutorials[1];
        // return this.exercise_videos + '/' + this.activity.original_name + '-' + this.activity.equipment + '-Male_2.gif';
      },

    },

    created() {
      this.rep_sets = this.activity.rep_sets;
    },

    mounted() {
      //
    },


    methods: {
      overwrite_rep_sets(rep_sets) {
        this.rep_sets = rep_sets;
        this.reset_rep_set_pickers();
      },
    },

    watch: {
      activity: {
        deep: true,
        handler() {
          // just for the trigger
        }
      }
    }
  };
</script>
<style lang="scss">
  swiper-container {
    --swiper-navigation-color: #000;
    --swiper-theme-color: #000;
  }

  .activity-swiper-card {
    flex-shrink: 0;
    /*width: 100%;*/
    height: 100%;
    position: relative;
    transition-property: transform;

    .muscle-image-container {
      height: 50vh;
    }
    .muscle-image {
      position:absolute;
      height: 45vh;
      //width: 95vw;
      top:4px;
    }
  }
</style>
